import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { ProductCoatingCompatibility } from 'src/enums/stowage/stowageRule/productCoatingCompatibility';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const coatingCompatibilityHardRule: StowageRuleBM = {
    id: StowageRuleId.CoatingCompatibilityHardRule,
    name: 'Coating compatibility to be verified by MSG or in the resistance list.',
    lastUpdatedUtc: '2024-07-23T00:00:00.000',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                leaf: {
                    properties: [
                        {
                            name: 'IsCoatingCompatible',
                            fieldPath: 'getCoatingCompatibility',
                            type: 'string',
                            location: StowageRulePropertyLocation.Tank,
                        },
                        {
                            name: 'ReferenceValue',
                            type: 'number',
                            referenceValue: ProductCoatingCompatibility.No.toString(),
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.Equals,
                },
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.HardRule,
        parameter: 'Incompatible coating.',
    },
};
